// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1205":"37d8231f","2497":"5847fb97","3243":"e3c38864","5440":"1928e98e","9099":"bb5aaef1"}[chunkId] + ".chunk.css";
};